import { Class } from "core/Abacus.Utilities";
import { SpinnerClass } from "core/classes/spinner.class";

$(function() {
  if (!document.querySelector("#ratingAjax")) return;
  const selector = document.querySelector("#ratingAjax");
  $(window).on("abacus:loadcontent:complete", function(evt, context) {
    if (context[0].id == "ratingAjax") {
      new StoryRating(selector);
    }
  });
});

const StoryRatingOptions = {
  stars: "li"
};

class StoryRating extends Class {
  constructor(element, options) {
    super();
    this.element = $(element).find(".rating-module");
    this.setOptions(StoryRatingOptions, options);
    this.setUp();
    this.setUpEvents();
  }

  setUp() {
    this.options.haveVoted = $(this.element).data("ratingModuleVoted");
  }

  setUpEvents() {
    let star = $(this.element).find(this.options.stars),
      self = this;
      for (let li of star){
       (self.options.haveVoted != true) ?  li.tabIndex=0 : li.tabIndex=-1;       
      }

    if (star.filter(".star-over") && this.options.haveVoted) return;
    star.on("mouseover", function() {
      self.applyOverClass(this);
    });
    star.on("mouseout", function() {
      self.removeOverClass(this);
    });
    star.on("click keypress", function(e) {
      if(e.type === "click" || e.which === 13){
         self.options.haveVoted = true;
         self.applyOverClass(this);
         self.postRequest(this);
      }
    });
  
  }
  
  applyOverClass(star) {
    $(star)
      .prevAll()
      .addBack()
      .addClass("star-over");
  }

  removeOverClass(star) {
    if (this.options.haveVoted) return;
    $(star)
      .prevAll()
      .addBack()
      .removeClass("star-over");
  }

  postRequest(element) {
    let clickedStar = element.dataset.starValue,
      storyCode = $(this.element).data("storyCode"),
      self = this.element;
    $.ajax({
      url: "/0/0/ratestory",
      method: "post",
      data: {
        clickedStar,
        storyCode
      },
      beforeSend: () => {
        $(self).addClass("ui-loading");
        self.spinner = new SpinnerClass(self, {
          spinnerOptions: {
            color: "black"
          }
        });
      },
      success: data => {
        $(self).replaceWith(data);
        self.spinner.spinner.stop();
      },
      error: xhrObj => {
        $(self)
          .find(".sleeve")
          .replaceWith(
            '<div class="sleeve"><p>Sorry, we\'re unable to submit your rating. Please try again later.</p></div>'
          );
        $(self).removeClass("ui-loading");
        self.spinner.spinner.stop();
        console.warn(
          `Sorry, unable to submit rating. Status code is ${xhrObj.status}`
        );
      }
    });
  }
}

export default StoryRating;



// WEBPACK FOOTER //
// ./Javascript/core/classes/story/rating.class.js